export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9745.70c3106c.jpg";